// Detects the visitor's country via a free, no-key IP geolocation API so the
// pricing page can show the right currency (far more reliable than browser
// language). Short timeout + session cache; returns a 2-letter country code
// or null, in which case callers fall back to browser-language currency.
let cached;

export const detectCountry = async () => {
  if (cached !== undefined) return cached;
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 2000);
    const res = await fetch("https://api.country.is/", {
      signal: controller.signal,
    });
    clearTimeout(timer);
    if (!res.ok) throw new Error("geo lookup failed");
    const data = await res.json();
    cached = (data && data.country) || null;
  } catch {
    cached = null;
  }
  return cached;
};
